import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';




@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css']
})
export class AdminDashboardComponent implements OnInit {

  constructor(public global: GlobalService){}

  displayedColumns: string[] = ['userid', 'name', 'email', 'exdate'];
  dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);

//  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  ngOnInit() {
  //  this.dataSource.paginator = this.paginator;
  }
}

export interface PeriodicElement {
  name: string;
  userid: string;
  email: string;
  exdate: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {userid: 'agent', name: 'agent', email: 'agent@gmail.com', exdate: '31-12-2020' },
  {userid: 'customer', name: 'sathya', email: 'sathya@gmail.com', exdate: '31-12-2020' },
  {userid: 'admin', name: 'admin', email: 'admin@gmail.com', exdate: '31-12-2020' },
  {userid: 'guest', name: 'sathish', email: 'sathish@gmail.com', exdate: '31-12-2020' },
  {userid: 'admin', name: 'admin', email: 'admin@gmail.com', exdate: '31-12-2020' }
];